<template>
    <div>
        <div class="rptList" v-for="noteMonth in noteList">
            <div class="maincontent el-row">
                <div class="left el-col el-col-1">
                    <div class="circleName">
                        <div class="name" style="background: rgb(255, 127, 0);">
                            <span>{{noteMonth.summary}}</span></div>
                    </div>
                </div>
                <div class="el-col el-col-23">
                    <div class="right">
                        <div class="right_header el-row">
                            <div class="el-col el-col-10">
                                <div class="titleLeft">
                                    <div class="titleTime">
                                        <div class="titleDate">
                                            <span>{{noteMonth.year}}-</span> <span
                                                class="timeday">{{noteMonth.summary}}</span>
                                        </div>
                                        <div class="titleWeek">({{noteMonth.start}}~{{noteMonth.end}})</div>
                                    </div>
                                </div>
                            </div>
                            <div class="titleRight">

                            </div>
                        </div>
                        <NoteCard :plan=noteMonth.plan :planType="planType" :planTypeName="planTypeName" :startDate="noteMonth.year+'/'+noteMonth.start" :endDate="noteMonth.year+'/'+noteMonth.end"></NoteCard>
                        <div class="line10px"></div>
                    </div>
                </div>
            </div>
        </div>
        <div style="text-align: center;padding: 10px">
            <a @click="loadMoreMonthNotes">
                <i class="fa fa-arrow-circle-o-down" style="margin-right: 5px"></i>加载更多月报</a>
        </div>
    </div>
</template>

<script>
    import NoteCard from '@/apps/plan/sub_components/cards/note_card.vue'
    import planApi from '@/api/plan/plan_api.js'

    export default {
        name: "week_notes",
        components: {NoteCard},
        data: function () {
            return {
                theMonth: (new Date()),
                planTypeName: '月',
                my_plans: [],
                planType: 'month',
                noteList: []
            }
        },
        methods: {
            getMonthsWithYear() {
                let months = [];
                let currentMonth = this.theMonth.getMonth() + 1
                let years = this.theMonth.getFullYear();
                for (let i = 1; i < (currentMonth + 1); i++) {
                    let month = new Object();
                    let d = new Date(years, i, 0);
                    month.year = years
                    month.start = i + '/01';
                    month.end = i + '/' + d.getDate();
                    month.summary = i + '月 ';
                    month.monthIdx = i
                    month.plan = this.monthPlan(new Date(years + '/' + month.start));
                    months.push(month);
                }
                months.sort(this.compare)
                for (let i = 0; i < months.length; i++) {
                    this.noteList.push(months[i]);
                }
                return months;
            },
            loadMoreMonthNotes: function () {
                let args = {
                    'sdate': this.theMonth.getFullYear() + '-01-01',
                    'edate': (this.theMonth.getFullYear() + 1) + '-01-01',
                    'ptype': 'month',
                }
                planApi.get_my_plans_by_date(args).then((res) => {
                    this.my_plans = res.data;
                    this.getMonthsWithYear()
                    let years = this.theMonth.getFullYear() - 1
                    this.theMonth = new Date(years + '-' + 12 + '-01')
                })

            },
            compare: function (obj1, obj2) {
                let val1 = obj1.monthIdx;
                let val2 = obj2.monthIdx;
                if (val1 < val2) {
                    return 1;
                } else if (val1 > val2) {
                    return -1;
                } else {
                    return 0;
                }
            },
            monthPlan: function (start) {
                let p = []
                console.log('his.my_plans[i]'+this.my_plans.length)
                console.log('start'+start)
                for (var i = 0; i < this.my_plans.length; i++) {
                    if (this.my_plans[i].plan_type === "month" && (new Date(this.my_plans[i].open_time)).getFullYear() == start.getFullYear() && (new Date(this.my_plans[i].open_time)).getMonth() == start.getMonth() && (new Date(this.my_plans[i].open_time)).getDate() == start.getDate()) {
                        p.push(this.my_plans[i])
                        break
                    }
                }
                return p.length > 0 ? p[0] : null
            },
        },
        computed: {},
        mounted() {
            this.loadMoreMonthNotes()
        }
    }
</script>

<style scoped>
    .circleName {
        display: inline-block;
        width: 100%;
    }

    .circleName .name {
        border-radius: 100px;
        float: left;
        margin-left: 10px;
        display: inline-block;
        text-align: center;
        color: #fff;
        font-size: 12px;
        margin-bottom: 15px;
        width: 40px;
        height: 40px;
        background: #ff7f00;
        line-height: 40px;
    }

    .rptList {
        width: 96%;
        margin-left: 2%;
        display: inline-block;
        background: #eee;
    }

    .rptList .maincontent {
        width: 100%;
        border: 1px solid #ddd;
        background: #fff;
        margin-bottom: 3px;
        padding-bottom: 15px;
    }

    .rptList .right {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
    }

    .rptList .left {
        margin-top: 15px;
    }

    .el-row {
        margin-bottom: 3px;
        padding-bottom: 15px;
    }

    .rptList .right .right_header {
        display: inline-block;
        border-bottom: 1px solid #ddd;
        width: 98%;
        margin-left: 1%;
    }

    .rptList .right .right_header .titleLeft {
        float: left;
        font-size: 16px;
        margin-top: 24px;
    }

    .rptList .right .right_header .titleLeft .titleTime {
        float: left;
        margin-left: 10px;
        line-height: 22px;
    }

    .rptList .right .right_header .titleLeft .titleTime .titleDate {
        float: left;
    }

    .rptList .right .right_header .titleLeft .titleTime .titleDate .timeday {
        color: #390;
    }

    .rptList .right .right_header .titleLeft .titleTime .titleWeek {
        float: left;
        margin-left: 6px;
        font-size: 12px;
        line-height: 20px;
        letter-spacing: 2px;
    }

    .rptList .right .right_header .titleRight {
        float: right;
        height: 40px;
        line-height: 40px;
        margin-top: 10px;
        margin-right: 20px;
    }

    .el-row:after, .el-row:before {
        display: table;
    }

    .el-col-1, .el-col-23, .el-col-10 {
        float: left;
        box-sizing: border-box;
    }

    .el-col-1 {
        width: 4.16667%;
    }

    .el-col-23 {
        width: 95.83333%;
    }

    .el-col-10 {
        width: 41.66667%;
    }

    .el-col {
        padding-left: 10px;
        padding-right: 10px;
    }


</style>